export default __webpack_public_path__ + "static/media/senor-burdy.91417ee1.png";